
import XHeader from 'vux/src/components/x-header/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import Clocker from 'vux/src/components/clocker/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import Vue from "vue";

export default {
components: {
XHeader,
Checker,
CheckerItem,
Swiper,
SwiperItem,
Checklist,
Flexbox,
FlexboxItem,
XButton,
Group,
Cell,
Box,
XProgress,
Clocker,
XTextarea,
Selector,
XSwitch,
Rater,
LoadMore
},
data() {
return {
isBack: false, //允许返回
showtime: this.$route.query.showtime, //做题类型
examshowtime: this.$route.query.examshowtime, //做题类型
chapterId: this.$route.query.chapterid, //章节编号
subjectid: this.$route.query.subjectid, //题目编号
paperId: this.$route.query.paperId, //试卷编号
errtype: this.$route.query.errtype, //错题类型 1:待解决 2已解决
errobj: this.$route.query.errobj, //错题对象 0章节 1次数 2周期
errvalue: this.$route.query.errvalue, //错题选择的值 (分别对应章节id，次数序号，周期序号）
listId: this.$route.query.listid, //题目列表编号
paperInfo: {}, //试卷信息
showModelType: this.GLOBAL.SubjectShowModelType.Content, //显示模块
subjectList: [], //题目列表
swiperSubjectList: [], //轮播组件题目列表
localSubjectObj: {}, //本地已缓存题目列表
localWriteNoteObj: {}, //本地已缓存的笔记
subjectSwiper: -1, //当前所在的题目
subjectSwiperValue: 1, //当前轮播组件位置
subjectIsCollected:false,
answerTypeCheckerItem: "", //当前选择的答题情况
writeNoteType: "0", //笔记类型 0我的笔记 1网友笔记
otherCustomerNote: [], //网友笔记
isOtherCustomerNoteLoadMore: false, //显示加载更多网友笔记等候图标
isShowOtherCustomerNoteLoadMore: true, //显示加载更多网友笔记按钮
currentOtherCustomerNotePageIndex: 1, //网友笔记当前页数
currentWriteNote: "", //当前笔记内容
currentWriteNoteId: 0, //当前笔记编码
errorType: "0", //错误类型 0答案有错 1题目有错
errorText: "", //错误内容
fontList: [
{ key: "0", value: "小号" },
{ key: "1", value: "中号" },
{ key: "2", value: "大号" },
{ key: "3", value: "特大" },
{ key: "4", value: "超大" }
], //字体选项
settingFont: "1", //字体大小
nightMode: false, //夜晚模式
greenMode:false,
moveNextType:false,//答题后移动到下一题
showAnswerAfterDo:true,//答题后是否自动显示答案
forceShowAnswer:false,//强制显示答案
barstyle:{bgcolor:"#29aae3", forecolor:"#fff", nightmode:false, greenmode:false},
funimgurl0:require('../assets/file_group.png'),
clearTestHistory: false, //清空练习记录
clearCollect: false, //清空我的收藏
clearSimulationPaper: false, //清空模拟考试记录
startDate: new Date(), //开始时间
totalScore: 100, //总分
resultScore: 0, //获得的分数
resultScoreRate: 0, //得分率
resultRightCount: 0, //答对数量
resultWrongCount: 0, //答错数量
resultFinishRate: 0, //准确率
usetime: 0 
};
},
beforeRouteLeave(to, from, next) {
next(this.isBack);
},
created() {
this.createData();
},
methods: {
createData() {

if (this.isTest) {
if (this.listId != undefined && this.listId > 0) {
this.LoadSubjectListByRefList();
return;
}
}

this.$vux.loading.show({
text: "请稍候..."
});

if (this.isTest) {

this.LoadSubjectListByChapterId();
} else if (this.isExam || this.isView) {

if (this.paperId != undefined && this.paperId > 0) {
this.LoadPaperDetail();
}
} else if (this.isOtherTest) {

this.LoadSubjectList();
}
},
initData() {
this.paperInfo = {};
this.subjectList = [];
this.swiperSubjectList = [];
this.localSubjectObj = {};
this.localWriteNoteObj = {};
this.otherCustomerNote = [];
this.currentWriteNote = "";
this.currentWriteNoteId = 0;
this.startDate = new Date();

this.loadSettings();
},
loadSettings(){

var myset = this.$store.getters.getSettingInfo;

if (myset != undefined) {
this.settingFont = myset.FontSize;
this.nightMode = myset.NightMode == 1;
if(myset.GreenMode != undefined) this.greenMode = (myset.GreenMode == 1);
if(myset.MoveNextType != undefined) this.moveNextType = (myset.MoveNextType == 1);
if(myset.ShowAnswerAfterDo != undefined) this.showAnswerAfterDo = (myset.ShowAnswerAfterDo == 1);

}

this.barstyle = this.GLOBAL.getNavigationBarStyle(myset);




},
updateLocalSettings(){
var localSettingInfo = {
FontSize: this.settingFont,
LongBright: 0,
NightMode: this.nightMode ? 1 : 0,
GreenMode: this.greenMode ? 1 : 0,
MoveNextType: this.moveNextType ? 1 : 0,
ShowAnswerAfterDo: this.showAnswerAfterDo ? 1 : 0
};
this.$store.commit("$_setSettingInfo", localSettingInfo);
},
LoadSubjectListByChapterId() {
this.initData();
this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubjectListByChapterId",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
chapterId: this.chapterId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {

response.data.data.forEach(subject => {
this.subjectList.push(subject.isubjectid);


this.localSubjectObj[subject.isubjectid] = {
isubjectid: subject.isubjectid,
cmyanswer: subject.cmyanswer,
cmyanswerlist: this.getAnswerToList(subject),
bcorrect: subject.bcorrect,
iscore: subject.iscore,
imyscore: subject.imyscore
};
});
}
this.gotoSubject();
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
LoadSubjectListByRefList() {
this.initData();
var stroageSubjectList = JSON.parse(
sessionStorage.getItem("subjectList")
);

if (
stroageSubjectList == undefined ||
stroageSubjectList.id != this.listId
) {
return;
}

stroageSubjectList.list.forEach(subject => {
this.subjectList.push(subject.isubjectid);


this.localSubjectObj[subject.isubjectid] = {
isubjectid: subject.isubjectid,
cmyanswer: subject.cmyanswer,
cmyanswerlist: this.getAnswerToList(subject),
bcorrect: subject.bcorrect,
iscore: subject.iscore,
imyscore: subject.imyscore
};
});

this.gotoSubject();
},
LoadPaperDetail() {
this.initData();


this.$http({
method: "post",
url: "wxexam.ashx?op=LoadPaperInfo",
params: {
paperId: this.paperId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.paperInfo = response.data.data[0];
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadPaperDetail",
params: {
paperId: this.paperId,
showTime: this.examshowtime
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
response.data.data.forEach(subject => {
this.subjectList.push(subject.isubjectid);


this.localSubjectObj[subject.isubjectid] = {
isubjectid: subject.isubjectid,
cmyanswer: subject.cmyanswer,
cmyanswerlist: this.getAnswerToList(subject),
bcorrect: subject.bcorrect,
iscore: subject.iscore,
imyscore: subject.imyscore
};
});
}


this.gotoSubject();
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
LoadSubjectList() {
this.initData();

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubjectList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
chapterId: this.chapterId,
showTime: this.showtime,
showtype: 1,
errtype: this.errtype,
errobj: this.errobj,
errvalue: this.errvalue
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {

response.data.data.forEach(subject => {
this.subjectList.push(subject.isubjectid);


this.localSubjectObj[subject.isubjectid] = {
isubjectid: subject.isubjectid,
cmyanswer: subject.cmyanswer,
cmyanswerlist: this.getAnswerToList(subject),
bcorrect: subject.bcorrect,
iscore: subject.iscore,
imyscore: subject.imyscore
};
});
}

this.gotoSubject();
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
gotoSubject() {

if (this.subjectid != undefined && this.subjectid > 0) {
for (var i = 0; i < this.subjectList.length; i++) {
if (this.subjectList[i] == this.subjectid) {
this.subjectSwiper = i;
break;
}
}
} else {
this.subjectSwiper = 0;
}

this.setSwiperList();
},
setSwiperList() {
var isemptylist = (this.swiperSubjectList.length == 0);

var indexs = [];
if(this.subjectSwiperValue == 0){
indexs = [0, 1, 2];
}
else if(this.subjectSwiperValue == 1)
indexs = [-1, 0, 1];
else if(this.subjectSwiperValue == 2)
indexs = [1, -1, 0];
var sid = 0;

for(var i = 0; i < 3; i++) {
sid = this.subjectSwiper + indexs[i];
if(sid<0)
sid = this.subjectList.length - 1;
else if(sid>=this.subjectList.length)
sid = 0;
if(isemptylist)
this.swiperSubjectList.push(this.subjectList[sid]);
else
this.swiperSubjectList[i] = this.subjectList[sid];
}




},
getSubjectIndex(subjectId){
var index = 0;
for (var i = 0; i < this.subjectList.length; i++) {
if (this.subjectList[i] == subjectId) {
index = i;

break;
}
}

return index;
},
getSubjuectInfo(index, subjectId) {

this.forceShowAnswer = false;



if (this.localSubjectObj.hasOwnProperty(subjectId)) {
if (this.localSubjectObj[subjectId].isubjecttype != undefined) {

this.$set(this.subjectList, index, subjectId);


return;
}
}


if (index == this.subjectSwiper) {
this.$vux.loading.show({
text: "请稍候..."
});
}

var onTest =
this.isExam || this.showtime == this.GLOBAL.SubjectShowTime.TestInError
? 0
: 1;

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubjuectInfo",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subjectId,
onTest: onTest
}
})
.then(response => {
if (response.status == 200) {
if (
response.data.errcode == 0 &&
response.data.data != undefined &&
response.data.data.length > 0
) {
var subjectInfo = response.data.data[0];

if (subjectInfo != undefined) {

if (onTest == 0) {
subjectInfo.cmyanswer = "";
} else {
subjectInfo.cmyanswerlist = this.getAnswerToList(subjectInfo);
}
this.localSubjectObj[subjectInfo.isubjectid] = subjectInfo;


this.$set(this.subjectList, index, subjectId);

}
}
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
updateCourseTestSubjectId(subjectId) {

this.$http({
method: "post",
url: "wxexam.ashx?op=UpdateCourseTestSubjectId",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
subjectId: subjectId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
getQuestionsNum(subject) {
var qs = this.getQuestions(subject, true);
if(qs)
return qs.length;
else
return 0;
},
getQuestions(subject, isNum) {
if(isNum == undefined) isNum = false;
var question = subject.cquestion || '';
var answercount = subject.ianswercount;
var lstAnswer = [];
var splitChar = [];
var ia = "A".charCodeAt();
for (var i = 0; i < answercount; i++) {
splitChar.push(String.fromCharCode(ia + i));
}


if (question == undefined || question.length == 0) {
if (!isNum && answercount != undefined && answercount > 0) {
for (var i = 0; i < answercount; i++) {
lstAnswer.push({
key: String.fromCharCode(ia + i),
value: String.fromCharCode(ia + i)
});
}
} else {
return [];
}
}

question = question.replace(/(^\s*)|(\s*$)/g, "");
var qchars = question;
var totallen = question.length;

if (lstAnswer.length == 0 && totallen > answercount) {

var preindex = 0,
startindex = 0;
var nextc = "\0";
if (qchars[0] == "A") {
nextc = qchars[1];
if (
nextc != "." &&
nextc != "、" &&
nextc != " " &&
nextc != ":" &&
nextc != "：" &&
nextc != "。" &&
nextc != "．"
) {
nextc = "\0";
}
}

for (var i = 1; i < answercount; i++) {
var c = splitChar[i];
var myindex = question.indexOf(c, preindex);
var find = false;
if (myindex > 0 && myindex < totallen - 1) {
while (myindex != -1) {
if (nextc == "\0") {
nextc = qchars[myindex + 1];
if (
nextc == "." ||
nextc == "、" ||
nextc == " " ||
nextc == ":" ||
nextc == "：" ||
nextc == "。" ||
nextc == "．"
) {
find = true;
} else nextc = "\0";
} else {
if (myindex < totallen - 1) find = nextc == qchars[myindex + 1];
}
if (find) {
lstAnswer.push({
key: String.fromCharCode(ia + i - 1),
value: question
.substring(startindex, myindex)
.replace(/(^\s*)|(\s*$)/g, "")
});
startindex = myindex;
preindex = myindex + 1;
if (i == answercount - 1) {
lstAnswer.push({
key: String.fromCharCode(ia + i),
value: question.substring(startindex)
});
}
break;
} else {
if (myindex < totallen - 1) {
preindex = myindex + 1;
myindex = question.indexOf(c, preindex);
continue;
} else break;
}
}

if (!find){


break;
}
}
}
}

if (lstAnswer.length != answercount) {

if (!isNum && answercount != undefined && answercount > 0) {
for (var i = lstAnswer.length; i < answercount; i++) {
lstAnswer.push({
key: String.fromCharCode(ia + i),
value: String.fromCharCode(ia + i)
});
}
} else {
lstAnswer = [];
}
}



return lstAnswer;
},
getAnswerToList(subject) {
if (subject == undefined) {
return [];
}

if (
subject.isubjecttype != this.GLOBAL.SubjectType.SingleSelect &&
subject.isubjecttype != this.GLOBAL.SubjectType.MultiSelect &&
subject.isubjecttype != this.GLOBAL.SubjectType.Check &&
subject.isubjecttype != this.GLOBAL.SubjectType.MultiGuess &&
subject.isubjecttype != this.GLOBAL.SubjectType.Relation
) {
return [];
}

var answer = subject.cmyanswer;

if (answer == null || answer.length == 0) {
return [];
}

var result = [];
if (subject.isubjecttype == this.GLOBAL.SubjectType.Relation) {

var answers = answer.split(",");
answers.forEach(item => {
var tmp = [];
for (var i = 0; i < item.length; i++) {
tmp.push(item.charAt(i));
}
result.push(tmp);
});
} else {
for (var i = 0; i < answer.length; i++) {
result.push(answer.charAt(i));
}
}
return result;
},
getRelationAnswerList(answerList, index){

if(!answerList) return "";
return answerList[index];
},
changeRadio(value, label, subject, index) {

var val = value.length > 0 ? value[0] : "";
if (val.length > 0 && val != subject.cmyanswer) {
this.setMyAnswer(subject, val, index);
if (this.isExam || this.moveNextType)
{
this.nextSubjectAfterAnswer();
}
}
},
changeCheckList(value, label, subject, index) {

var val = "";
if (value.length > 0) {
value = value.sort();
value.forEach(item => {
val = val + item;
});
}
this.setMyAnswerTmp(subject, val, index);
},
changeRadioByRelation(value, label, subject, index, relationIndex, count) {

var val = value.length > 0 ? value[0] : "";
if (
!subject.hasOwnProperty("cmyanswertmp") ||
subject.cmyanswertmp.length == 0
) {
subject.cmyanswertmp = new Array(count);
}
subject.cmyanswertmp[relationIndex] = val;
this.setMyAnswerTmp(subject, subject.cmyanswertmp, index);
},
changeCheckListByRelation(
value,
label,
subject,
index,
relationIndex,
count
) {

var val = "";
if (value.length > 0) {
value = value.sort();
value.forEach(item => {
val = val + item;
});
}

if (
!subject.hasOwnProperty("cmyanswertmp") ||
subject.cmyanswertmp.length == 0
) {
subject.cmyanswertmp = new Array(count);
}

subject.cmyanswertmp[relationIndex] = val;
this.setMyAnswerTmp(subject, subject.cmyanswertmp, index);
},
enterSubject(subject, index) {

if (
(subject.isubjecttype == this.GLOBAL.SubjectType.MultiSelect ||
subject.isubjecttype == this.GLOBAL.SubjectType.MultiGuess) &&
subject.hasOwnProperty("cmyanswertmp") &&
subject.cmyanswertmp.length > 0
) {

this.setMyAnswer(subject, subject.cmyanswertmp, index);
if (this.isExam || this.moveNextType) {
this.nextSubjectAfterAnswer();
}
} else if (
subject.isubjecttype == this.GLOBAL.SubjectType.Text ||
subject.isubjecttype == this.GLOBAL.SubjectType.Memo ||
subject.isubjecttype == this.GLOBAL.SubjectType.SingleText
) {

this.setMyAnswer(subject, subject.cmyanswer, index);
if (this.isExam || this.moveNextType) {
this.nextSubjectAfterAnswer();
}
} else if (
subject.isubjecttype == this.GLOBAL.SubjectType.Relation &&
subject.hasOwnProperty("cmyanswertmp") &&
subject.cmyanswertmp.length > 0
) {

var val = "";
for (var i = 0; i < subject.cmyanswertmp.length; i++) {
val =
val +
(i > 0 ? "," : "") +
(subject.cmyanswertmp[i] == undefined
? ""
: subject.cmyanswertmp[i]);
}
this.setMyAnswer(subject, val, index);

if (this.isExam || this.moveNextType) {
this.nextSubjectAfterAnswer();
}
}
},
clearanswer(subject, index) {

this.setMyAnswer(subject, "", index);
this.setMyAnswerTmp(subject, "", index);
this.updateSubjectAnswer(subject, index);
},
dowriteerror(subject, index) {

this.changeModelType(this.GLOBAL.SubjectShowModelType.Error);
this.loadSubjectError();
},
loadSubjectError() {

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubjectError",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: this.currentSubject.isubjectid
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
if (
response.data.data != undefined &&
response.data.data.length > 0
) {
this.errorType = response.data.data[0].ierrortype.toString();
this.errorText = response.data.data[0].cerrortext;
}
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
submitError() {

this.$http({
method: "post",
url: "wxexam.ashx?op=WriteSubjectError",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: this.currentSubject.isubjectid,
errorType: this.errorType,
errorText: this.errorText
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.$vux.toast.text("提交纠错信息成功！", "bottom");
this.changeModelType(this.GLOBAL.SubjectShowModelType.Content);
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
setMyAnswerTmp(subject, value, index) {

subject.cmyanswertmp = value;
},
setMyAnswer(subject, value, index) {

subject.cmyanswer = value;
subject.cmyanswerlist = this.getAnswerToList(subject);

Vue.set(this.localSubjectObj, subject.isubjectid, subject);
Vue.set(this.swiperSubjectList, this.subjectSwiperValue, subject.isubjectid);


if (subject.cmyanswer.length > 0) {
this.updateSubjectAnswer(subject, index);
}
},
updateSubjectAnswer(subject, index) {

if (this.isExam) {
if (this.paperId != undefined && this.paperId > 0) {

this.$http({
method: "post",
url: "wxexam.ashx?op=UpdateSubjectAnswerInPaper",
params: {
paperId: this.paperId,
subjectId: subject.isubjectid,
myAnswer: subject.cmyanswer
}
})
.then(response => {
if (response.status == 200) {
if (response.data.data != undefined) {
subject.imyscore = response.data.data;

if (subject.imyscore == subject.iscore) {
subject.bcorrect = true;
}
else
subject.bcorrect = false;
Vue.set(this.localSubjectObj, subject.isubjectid, subject);
Vue.set(this.swiperSubjectList, this.subjectSwiperValue, subject.isubjectid);
} else if (response.data.errmsg.length > 0) {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
} else {

this.$http({
method: "post",
url: "wxexam.ashx?op=UpdateSubjectMyAnswer",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subject.isubjectid,
myAnswer: subject.cmyanswer
}
})
.then(response => {
if (response.status == 200) {
if (response.data.data != undefined) {
subject.imyscore = response.data.data;

if (subject.imyscore == subject.iscore) {
subject.bcorrect = true;
}
else
subject.bcorrect = false;
Vue.set(this.localSubjectObj, subject.isubjectid, subject);
Vue.set(this.swiperSubjectList, this.subjectSwiperValue, subject.isubjectid);
} else if (response.data.errmsg.length > 0) {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
subjectIsAnswer(subject) {

return subject.cmyanswer != null && subject.cmyanswer.length > 0;
},
checkAnswer(subject) {

if (
subject == {} ||
subject.cmyanswer == undefined ||
subject.cmyanswer == null ||
subject.cmyanswer == ""
) {
return 0;
}

if (subject.bcorrect) {
return 11; 
} else if (!subject.bcorrect && subject.imyscore > 0) {
return 12; 
} else {
return 13; 
}
},
isWithoutAnswer(){
var subject = this.currentSubject;
if(!subject || subject.isubjecttype == undefined) return false;
return subject.isubjecttype == this.GLOBAL.SubjectType.Text
|| subject.isubjecttype == this.GLOBAL.SubjectType.Memo
|| subject.isubjecttype == this.GLOBAL.SubjectType.SingleText;
},
subjectIsCollect() {

if (this.currentSubject) {
return this.currentSubject.bcollect;
} else {
return false;
}
},
collectSubject() {

var subject = this.currentSubject;
var isCollect = this.subjectIsCollect();
this.$http({
method: "post",
url: isCollect
? "wxexam.ashx?op=DoDeleteCollectSubject"
: "wxexam.ashx?op=DoCollectSubject",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subject.isubjectid
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
var index = 0;

this.subjectList.forEach(subjectId => {
if (subjectId == subject.isubjectid) {
subject.bcollect = !isCollect;
Vue.set(this.localSubjectObj, subject.isubjectid, subject);
this.subjectIsCollected = subject.bcollect;
return;
}
index++;
});



this.$vux.toast.text(
(isCollect ? "取消收藏" : "收藏") + "成功",
"bottom"
);
}
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
searchOtherCustomerNote(isMore) {
if (!isMore) {
this.otherCustomerNote = [];
}

this.isOtherCustomerNoteLoadMore = true;
this.isShowOtherCustomerNoteLoadMore = false;


this.$http({
method: "post",
url: "wxexam.ashx?op=SearchOtherCustomerNote",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: this.currentSubjectId,
pageSize: 20,
pageIndex: this.currentOtherCustomerNotePageIndex
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
if (isMore) {
response.data.data.forEach(item => {
this.otherCustomerNote.push(item);
});
} else {
this.otherCustomerNote = response.data.data;
}
this.currentOtherCustomerNotePageIndex++;

if (this.otherCustomerNote.length >= 20) {
this.isShowOtherCustomerNoteLoadMore = true;
}
this.isOtherCustomerNoteLoadMore = false;
}
}
})
.catch(function(error) {
this.isOtherCustomerNoteLoadMore = false;
console.log("error:" + error);
});
},
loadMySubjectNoteList(subjectId, isReload) {


if (this.localWriteNoteObj.hasOwnProperty(subjectId) && !isReload) {
return;
}

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadMySubjectNoteList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subjectId
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.localWriteNoteObj[subjectId] = response.data.data;

if (isReload) {

if (this.subjectSwiper == 0) {
this.nextSubject();
this.preSubject();
} else {
this.preSubject();
this.nextSubject();
}
}
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
modifySubjectNote(writeNote) {

this.currentWriteNote = writeNote.cnotetext;
this.currentWriteNoteId = writeNote.id;
this.changeModelType(this.GLOBAL.SubjectShowModelType.WriteNote);
},
doDeleteSubjectNote(writeNote) {

const _this = this;
this.$vux.confirm.show({
title: "删除笔记",
content: "您确定要删除笔记吗？",
onConfirm() {
var subjectId = _this.subjectList[_this.subjectSwiper];
_this
.$http({
method: "post",
url: "wxexam.ashx?op=DoDeleteSubjectNote",
params: {
noteId: writeNote.id
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
_this.$vux.toast.text("删除笔记成功", "bottom");
_this.changeModelType(
_this.GLOBAL.SubjectShowModelType.Content
);


_this.loadMySubjectNoteList(subjectId, true);
} else {
_this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
_this.$vux.toast.text(error, "bottom");
console.log("error:" + error);
});
}
});
},
submitWriteNote() {

if (this.currentWriteNote.length == 0) {
this.$vux.toast.text("请输入笔记内容", "bottom");
return;
}

var subjectId = this.currentSubjectId;
if (this.currentWriteNoteId > 0) {
this.$http({
method: "post",
url: "wxexam.ashx?op=ModifySubjectNote",
params: {
noteId: this.currentWriteNoteId,
noteText: this.currentWriteNote
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.$vux.toast.text("修改笔记成功", "bottom");
this.changeModelType(this.GLOBAL.SubjectShowModelType.Content);


this.loadMySubjectNoteList(subjectId, true);
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
this.$vux.toast.text(error, "bottom");
console.log("error:" + error);
});
} else {
this.$http({
method: "post",
url: "wxexam.ashx?op=WriteSubjectNote",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subjectId: subjectId,
noteText: this.currentWriteNote
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.$vux.toast.text("记录笔记成功", "bottom");
this.changeModelType(this.GLOBAL.SubjectShowModelType.Content);


this.loadMySubjectNoteList(subjectId, true);
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
this.$vux.toast.text(error, "bottom");
console.log("error:" + error);
});
}
},
nightModeChange(e){
if(e && this.greenMode) this.greenMode = false;
this.updateLocalSettings();
this.loadSettings();
},
greenModeChange(e){
if(e && this.nightMode) this.nightMode = false;
this.updateLocalSettings();
this.loadSettings();
},

changeModelType(type) {


if (this.showModelType == this.GLOBAL.SubjectShowModelType.Setting) {
this.$http({
method: "post",
url: "wxexam.ashx?op=UpdateExamSettings",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
fontsize: this.settingFont,
LongBright: 0,
nightmode: this.nightMode ? 1 : 0,
greenMode: this.greenMode ? 1 : 0,
moveNextType: this.moveNextType ? 1 : 0,
showAnswerAfterDo: this.showAnswerAfterDo ? 1 : 0
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
var settings = response.data;
this.updateLocalSettings();
this.loadSettings();
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}


this.showModelType = type;


if (this.showModelType == this.GLOBAL.SubjectShowModelType.WriteNote) {
this.searchOtherCustomerNote(false);
}

if (this.showModelType != this.GLOBAL.SubjectShowModelType.WriteNote) {
this.currentWriteNote = "";
this.currentWriteNoteId = 0;
this.writeNoteType = "0";
this.currentOtherCustomerNotePageIndex = 1;
}

if (this.showModelType != this.GLOBAL.SubjectShowModelType.Error) {
this.errorType = "0";
this.errorText = "";
}

if (this.showModelType == this.GLOBAL.SubjectShowModelType.Clear) {
this.clearTestHistory = false;
this.clearCollect = false;
this.clearSimulationPaper = false;
}






var headTitles = document.getElementsByClassName('vux-header-title');
if(headTitles){
for(var i=0;i<headTitles.length;i++){
headTitles[i].style.color = this.barstyle.forecolor;
}
}

},
preSubject() {

if (this.subjectSwiper > 0) {
this.subjectSwiper--;
} else if (this.subjectList != undefined && this.subjectList.length > 0) {
this.subjectSwiper = this.subjectList.length - 1;
}

this.setSwiperList();

},
nextSubject() {

if (
this.subjectList != undefined &&
this.subjectList.length > 0 &&
this.subjectSwiper >= this.subjectList.length - 1
) {
if (this.isOtherTest || this.isTest) {
this.$vux.alert.show({
title: "提示",
content:
"亲，已完成该章节所有题，请点击左上角返回，选择别的章节试卷做题~"
});
return;
} else if (this.isExam) {
var _this = this;
this.$vux.confirm.show({
title: "提示",
content: "亲，已经是最后一题了，是否提交试卷？",
onConfirm() {
_this.changeModelType(_this.GLOBAL.SubjectShowModelType.List);
}
});
return;
} else {
this.subjectSwiper = 0;
}
} else {
this.subjectSwiper++;
}

this.setSwiperList();

},
nextSubjectAfterAnswer(){
var _this = this;
setTimeout(function (){ _this.nextSubject();},500);
},
calcResult(data) {

var subitmDate = new Date();
this.usetime = (subitmDate.getTime() - this.startDate.getTime()) / 1000;

if (data.length > 0) {
this.resultScore = data[0].iscore;
this.resultRightCount = data[0].icorrectcount;
this.resultWrongCount = data[0].ierrcount;
this.totalScore = data[0].itotalscore;
this.resultFinishRate = data[0].icorrectrate;
}

/*
var score = this.$route.query.score;
if (score == undefined || parseInt(score) == 0) {
score = 0;
}

this.totalScore = parseInt(score);
this.resultScore = 0;
this.resultRightCount = 0;
this.resultWrongCount = 0;
this.subjectList.forEach(subjectId => {
var subject = this.localSubjectObj[subjectId];
if (subject.imyscore) {
this.resultScore = this.resultScore + subject.imyscore;
}

if(parseInt(score) == 0){
this.totalScore += subject.iscore;
}

var check = this.checkAnswer(subject);
if (check == 11) {
this.resultRightCount++;
} else if (check == 13) {
this.resultWrongCount++;
}
});

this.resultScoreRate = parseInt(
this.resultScore / this.totalScore * 10
);

this.resultFinishRate = (
this.resultRightCount /
this.subjectList.length *
100
).toFixed(0);
*/
},
submitSubject() {

const _this = this;
this.$vux.confirm.show({
title: "提交试卷",
content: "确定要提交试卷吗？",
onConfirm() {
_this.sumitPaper();
}
});
},
sumitPaper() {
this.$http({
method: "post",
url: "wxexam.ashx?op=SumitPaper",
params: {
paperId: this.paperId,
usetime: this.usetime
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
this.calcResult(response.data.data);
this.changeModelType(this.GLOBAL.SubjectShowModelType.ExamResult);
} else {
this.$vux.toast.text(response.data.errmsg, "bottom");
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
clearSubjectMyAnswer() {

const _this = this;
this.$vux.confirm.show({
title: "重新做题",
content: "确定要重新开始做题吗？",
onConfirm() {
_this
.$http({
method: "post",
url: "wxexam.ashx?op=ClearSubjectMyAnswer",
params: {
cusId: _this.$store.getters.getUserInfo.CusId,
courseId: _this.$store.getters.getClassInfo.CourseId,
chapterId: _this.chapterId
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
_this.$vux.toast.text("清空答题结果成功", "bottom");
_this.createData();
_this.changeModelType(GLOBAL.SubjectShowModelType.Content);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
});
},
clearCourse() {

const _this = this;
this.$vux.confirm.show({
title: "清空记录",
content: "确定要清空本课程的资料吗？",
onConfirm() {
_this
.$http({
method: "post",
url: "wxexam.ashx?op=ClearCourse",
params: {
cusId: _this.$store.getters.getUserInfo.CusId,
courseId: _this.$store.getters.getClassInfo.CourseId,
clearTestHistory: _this.clearTestHistory,
clearCollect: _this.clearCollect,
clearSimulationPaper: _this.clearSimulationPaper
}
})
.then(response => {
if (response.status == 200) {
if (response.data.errcode == 0) {
_this.$vux.toast.text("清空记录成功", "bottom");
_this.createData();
_this.changeModelType(GLOBAL.SubjectShowModelType.Content);
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
});
},
timeFinish() {
var _this = this;

this.$vux.alert.show({
title: "考试结束",
content: "考试时间到",
onHide() {
_this.sumitPaper();
}
});
},
onExamResultBtn() {


this.showtime = this.GLOBAL.SubjectShowTime.View;
this.examshowtime = this.GLOBAL.ExamShowTime.Test;

this.changeModelType(this.GLOBAL.SubjectShowModelType.Content);
},
subjuectBack() {
if (this.isExam) {
const _this = this;
this.$vux.confirm.show({
title: "退出提示",
content: "您正在考试，退出后成绩将作废，确定退出？",
onConfirm() {
_this.examBack();
}
});
} else {
this.examBack();
}
},
examBack() {
this.isBack = true;
this.$router.go(-1);
},
clickAnswerChecker(itemValue, itemDisabled) {

this.subjectSwiper = itemValue;
this.changeModelType(this.GLOBAL.SubjectShowModelType.Content);
this.setSwiperList();
},
numberPad(source, length = 2) {

let pre = "";
const negative = source < 0;
const string = String(Math.abs(source));
if (string.length < length) {
pre = new Array(length - string.length + 1).join("0");
}
return (negative ? "-" : "") + pre + string;
},
timeStamp2String(time) {
var datetime = new Date();
datetime.setTime(time);
var year = datetime.getFullYear();
var month =
datetime.getMonth() + 1 < 10
? "0" + (datetime.getMonth() + 1)
: datetime.getMonth() + 1;
var date =
datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
var hour =
datetime.getHours() < 10
? "0" + datetime.getHours()
: datetime.getHours();
var minute =
datetime.getMinutes() < 10
? "0" + datetime.getMinutes()
: datetime.getMinutes();
var second =
datetime.getSeconds() < 10
? "0" + datetime.getSeconds()
: datetime.getSeconds();
return (
year +
"-" +
month +
"-" +
date +
" " +
hour +
":" +
minute +
":" +
second
);
},
},
computed: {
subjectQuestionsClass: function() {

return {
subjectQuestionsNormal: !this.nightMode && !this.greenMode,
subjectQuestionsDark: this.nightMode,
subjectQuestionsGreen: this.greenMode,
subjectQuestions15: this.settingFontSize == "15px",
subjectQuestions17: this.settingFontSize == "17px",
subjectQuestions19: this.settingFontSize == "19px",
subjectQuestions21: this.settingFontSize == "21px",
subjectQuestions23: this.settingFontSize == "23px"
};
},
buttonClass: function() {

return {
enterBtn: !this.nightMode && !this.greenMode,
enterDarkBtn: this.nightMode,
enterGreenBtn: this.greenMode
};
},
checkerItemSelectClass: function() {
if(this.nightMode)
return 'darkCheckerItemSelect';
else if(this.greenMode)
return 'greenCheckerItemSelect';
else
return 'normalCheckerItemSelect';
},
groupSettingClass:function(){
if(this.nightMode)
return 'groupSettingDark';
else if(this.greenMode)
return 'groupSettingGreen';
else
return 'groupSetting';

},
writeNoteClass:function(){
if(this.nightMode)
return 'writeNoteDark';
else if(this.greenMode)
return 'writeNoteGreen';
else
return 'writeNote';

},
answerTextClass:function(){
if(this.nightMode)
return 'answerTextDark';
else if(this.greenMode)
return 'answerTextGreen';
else
return 'answerText';
},
settingFontSize: function() {

if (this.settingFont == "0") {
return "15px";
} else if (this.settingFont == "1") {
return "17px";
} else if (this.settingFont == "2") {
return "19px";
} else if (this.settingFont == "3") {
return "21px";
} else if (this.settingFont == "4") {
return "23px";
}
},
getFunImageUrl:function(){
var funname;
var suffix = (this.nightMode ? "_dark" : (this.greenMode ? "_green" : ""));
var prefix = "../assets/"
return(index)=>{
if(index == 0) //back
funname = "btn_back" + suffix;
else if(index == 1){
funname = "btn_sub_list" + suffix;
}
else if(index == 2){
funname = "btn_sub_collect" + suffix;
}
else if(index == 12){
funname = "btn_sub_collect1";
}
else if(index == 3){
funname = "btn_sub_write" + suffix;
}
else if(index == 4){
funname = "btn_sub_setting" + suffix;
}

return require("../assets/" + funname +".png")
}
},
swiperHeight: function() {

var height = document.documentElement.clientHeight - 82;
var topHeight =
this.$route.query.showtime == this.GLOBAL.SubjectShowTime.Examination
? 50
: 0;
return height - topHeight + "px";
},
currentSubjectId: function() {
return this.subjectList[this.subjectSwiper];
},
currentSubject: function() {
return this.localSubjectObj[this.subjectList[this.subjectSwiper]];
},
totalTime: function() {

var time = this.paperInfo.itotaltime;
if (time == undefined || parseInt(time) == 0) {
time = 120;
}
return parseInt(time);
},
endTime: function() {

var date = new Date();
var minutes = date.getMinutes();
date.setMinutes(minutes + this.totalTime);
return this.timeStamp2String(date.getTime());
},
subjectPercent: function() {

var count = 0;
this.subjectList.forEach(subjectId => {
if (this.subjectIsAnswer(this.localSubjectObj[subjectId])) {
count++;
}
});
return (count / this.subjectList.length) * 100;
},
subjectListOnList: function(type) {

var count = 0;
this.subjectList.forEach(subjectId => {
if (this.subjectIsAnswer(this.localSubjectObj[subjectId])) {
count++;
}
});
return (count / this.subjectList.length) * 100;
},
resultRightRate: function() {

return (this.resultRightCount / this.subjectList.length) * 100;
},
resultWrongRate: function() {

return (this.resultWrongCount / this.subjectList.length) * 100;
},
isCollect: function() {

return this.subjectIsCollect();
},
isTest: function() {
return this.showtime == this.GLOBAL.SubjectShowTime.Test;
},
isOtherTest: function() {
return (
this.showtime == this.GLOBAL.SubjectShowTime.TestInCollect ||
this.showtime == this.GLOBAL.SubjectShowTime.TestInError ||
this.showtime == this.GLOBAL.SubjectShowTime.TestInWriteNote ||
this.showtime == this.GLOBAL.SubjectShowTime.TestInEbbinghaus
);
},
isExam: function() {
return (
this.showtime == this.GLOBAL.SubjectShowTime.Examination ||
this.showtime == this.GLOBAL.SubjectShowTime.RedoError
);
},
isView: function() {
return this.showtime == this.GLOBAL.SubjectShowTime.View;
}
},
watch: {
subjectSwiperValue: function(newValue, oldValue) {

if(newValue - oldValue == 1 || newValue - oldValue == -2) {
this.nextSubject();
} else if (newValue - oldValue == -1 || newValue - oldValue == 2) {
this.preSubject();
}
},
subjectSwiper: function(newValue, oldValue) {

if(this.subjectList.length == 0) return;

for (
var i = newValue;
i <= newValue + 2 && i < this.subjectList.length;
i++
) {
this.getSubjuectInfo(i, this.subjectList[i]);
this.loadMySubjectNoteList(this.subjectList[i]);
}

this.subjectIsCollected = this.localSubjectObj[this.subjectList[newValue]].bcollect;

if (this.isTest) {
this.updateCourseTestSubjectId(this.subjectList[newValue]);
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/SubjuectData.vue